import useGetLocker from "./useGetLocker";

export const isLockerServiceProductRentalEnabled = (
  locker?: Pick<Locker, "service_product_rental"> | null
) => Boolean(locker?.service_product_rental);

export default function useLockerServiceProductRental() {
  const lockerQuery = useGetLocker();

  return {
    enabled: isLockerServiceProductRentalEnabled(lockerQuery.data),
    isReady: lockerQuery.isFetched,
  };
}
